import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    goodsName:'',
    //执行动作库存状态（1:在借 2：已取出，3：已归还,4:转借申请中，5:转借接受中，6:转借完成，7:转借失败，8：已同意，9：已拒绝）
    borrowRecordStatus:['','已领用','已取出','已归还','转借申请中','转借接受中','转借完成','转借失败','已同意','已拒绝','在借'],
    borrowRecordStatusByDataCensus:['','已领用','已取出','已取出','已领用','已领用','已领用','已领用','已领用','已领用','已领用'],
    unit:['','mL','g','mg','L','kg','KU','U'],
    lock:"disable" // 参数为 ：enable，disable

  },
  getters:{
  },
  mutations: {
    goodsName (state, goodsName) {
      state.goodsName = goodsName
    },
    
  },
  actions: {
    calNumberPoint(state,num){
      return Math.floor(num * 100) / 100;
    }
  },
  modules: {
  }
})
